import { render, staticRenderFns } from "./featuredCards.vue?vue&type=template&id=2b986d66&scoped=true"
import script from "./featuredCards.vue?vue&type=script&lang=js"
export * from "./featuredCards.vue?vue&type=script&lang=js"
import style0 from "./featuredCards.vue?vue&type=style&index=0&id=2b986d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b986d66",
  null
  
)

export default component.exports